import styled from 'styled-components';

// Cores fixas (preto/branco) e fonte monoespaçada -- estética de "nota
// fiscal"/cupom, de propósito diferente da ficha A4 (PrintWorkoutSheet).
export const Sheet = styled.div`
  display: none;

  @media print {
    display: flex;
    justify-content: center;
    padding: 24px;
  }
`;

export const Receipt = styled.div`
  width: 320px;
  padding: 20px 18px;
  border: 1px dashed #000;
  color: #111;
  background: #fff;
  font-family: 'Courier New', Courier, monospace;
`;

export const Center = styled.div`
  text-align: center;
`;

export const GymName = styled.div`
  font-size: 15px;
  font-weight: 700;
  text-transform: uppercase;
`;

export const DocTitle = styled.div`
  font-size: 12px;
  margin-top: 2px;
  letter-spacing: 0.05em;
`;

export const DashedLine = styled.div`
  border-top: 1px dashed #000;
  margin: 12px 0;
`;

export const FieldRow = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  margin-bottom: 4px;
`;

export const ExerciseItem = styled.div`
  margin-bottom: 10px;
  font-size: 11.5px;

  strong {
    display: block;
    font-size: 12.5px;
  }

  span {
    display: block;
    color: #333;
  }
`;

export const Footer = styled.div`
  margin-top: 16px;
  font-size: 10px;
  text-align: center;
`;
